import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Operario/getDeleteSeleccion`, method: 'POST', body: {list}, token: token})
}
